export default "__VITE_ASSET__DRgLpjnt__"